import { render, staticRenderFns } from "./RandomSet.vue?vue&type=template&id=700ff0f5&scoped=true&"
import script from "./RandomSet.vue?vue&type=script&lang=js&"
export * from "./RandomSet.vue?vue&type=script&lang=js&"
import style0 from "./RandomSet.vue?vue&type=style&index=0&id=700ff0f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700ff0f5",
  null
  
)

export default component.exports